import welcomeToSwitchAppImage from "../../assets/images/welcome-to-switchapp.svg";
import { ModalContainer, SwitchAppButton } from "../../components";

interface ISetupAccountModalProps {
  isModalOpen: boolean;
  closeModal: () => void;
  navigateToOnboarding: () => void;
}

export const SetupAccountModal = ({
  isModalOpen,
  closeModal,
  navigateToOnboarding,
}: ISetupAccountModalProps) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      selectorPrimaryFocus="button.get-started-button"
    >
      <div className="signup-success-modal col flex-container justify-content--center align-items--center">
        <img
          src={welcomeToSwitchAppImage}
          alt="welcome to switchapp"
          className="welcome-image mb-5"
        />

        <h2 className="font-ctm--bold mt-5 mb-5">Welcome to SwitchApp!</h2>

        <div className="flex-box flex-container col align-items--center justify-content--center">
          Payments with SwitchApp: seamless, faster and reliable,{" "}
          <br className="d-none d-md-block" />
          from your customers all over the world to you.
        </div>

        <div className="flex-box get-started-section">
          <h5 className="font-ctm--semibold">
            Let’s get you onboarded real quick.
          </h5>
        </div>

        <SwitchAppButton
          kind="primary"
          size="md"
          onClick={navigateToOnboarding}
          className="get-started-button mt-5"
        >
          Get started
        </SwitchAppButton>
      </div>
    </ModalContainer>
  );
};
